import {
  Search,
  Stethoscope,
  ClipboardList,
  Hammer,
  Rocket,
  LineChart,
  TrendingUp,
} from "lucide-react";

const stages = [
  {
    n: "01",
    icon: Search,
    title: "Discover",
    line: "You realize your online presence is not where it should be.",
    items: [
      "No website",
      "Weak branding",
      "Inconsistent social",
      "Gmail address",
      "No Google profile",
      "No lead follow-up",
    ],
    cta: "Start with a growth assessment.",
  },
  {
    n: "02",
    icon: Stethoscope,
    title: "Diagnose",
    line: "Agent Marketing reviews your current presence.",
    items: [
      "Brand review",
      "Website audit",
      "Google presence",
      "Social profiles",
      "Email setup",
      "Lead flow",
      "Listing assets",
      "Competition",
    ],
    cta: "A growth assessment showing what needs attention first.",
  },
  {
    n: "03",
    icon: ClipboardList,
    title: "Plan",
    line: "The right next step based on your stage, goals, and budget.",
    items: [
      "What matters now",
      "What can wait",
      "What is hurting trust",
      "Quick wins",
      "Long-term system",
    ],
    cta: "A clear growth plan you can act on.",
  },
  {
    n: "04",
    icon: Hammer,
    title: "Build",
    line: "We create the foundation or upgrade the system.",
    items: [
      "Branding",
      "Website",
      "Business email",
      "Google Profile",
      "Social banners",
      "Listing templates",
      "Business cards",
      "AI Reception",
      "CRM",
      "Automation",
    ],
    cta: "Every asset built to match one brand.",
  },
  {
    n: "05",
    icon: Rocket,
    title: "Launch",
    line: "Everything goes live in the correct order.",
    items: [
      "Website",
      "Profiles",
      "Forms",
      "Email",
      "Tracking",
      "CRM",
      "Automations",
      "Lead capture",
      "Review requests",
    ],
    cta: "A coordinated launch, not a scramble.",
  },
  {
    n: "06",
    icon: LineChart,
    title: "Manage",
    line: "Agent Marketing stays involved through ongoing presence management.",
    items: [
      "Updates",
      "Content",
      "Analytics",
      "Website management",
      "Google profile support",
      "Marketing advice",
      "Automation improvements",
    ],
    cta: "The system stays sharp as the business grows.",
  },
  {
    n: "07",
    icon: TrendingUp,
    title: "Grow",
    line: "As the business grows, the system grows with it.",
    items: [
      "SEO",
      "AI visibility",
      "Paid ads",
      "Lead funnels",
      "Recruiting systems",
      "Team pages",
      "Reputation management",
      "Advanced automations",
    ],
    cta: "Scale into a serious market position.",
  },
];

export default function JourneyStages({ compact = false }) {
  return (
    <div
      data-testid="journey-stages"
      className="grid md:grid-cols-2 lg:grid-cols-2 gap-6 lg:gap-8"
    >
      {stages.map((s, i) => {
        const Icon = s.icon;
        return (
          <div
            key={s.n}
            data-testid={`journey-stage-${s.n}`}
            className="reveal group relative border border-[#27272a] hover:border-[#C8A24B]/50 bg-[#0e0e0e] p-8 lg:p-10 transition-all duration-500"
          >
            <div className="flex items-start justify-between mb-6">
              <div className="w-12 h-12 border border-[#27272a] flex items-center justify-center bg-[#0a0a0a]">
                <Icon size={20} className="text-[#C8A24B]" strokeWidth={1.4} />
              </div>
              <span className="font-heading text-xs tracking-[0.28em] uppercase text-[#71717a]">
                Stage {s.n}
              </span>
            </div>
            <h3 className="font-heading text-2xl text-white mb-3">{s.title}</h3>
            <p className="text-[#d4d4d8] leading-relaxed">{s.line}</p>
            {!compact && (
              <>
                <ul className="mt-6 grid grid-cols-2 gap-2 text-[13px] text-[#a1a1aa]">
                  {s.items.map((it) => (
                    <li key={it} className="flex items-center gap-2">
                      <span className="w-1 h-1 rounded-full bg-[#C8A24B]" />
                      {it}
                    </li>
                  ))}
                </ul>
                <div className="mt-6 pt-6 border-t border-[#27272a] text-[13px] text-[#C8A24B]">
                  {s.cta}
                </div>
              </>
            )}
          </div>
        );
      })}
    </div>
  );
}

export { stages };
